import Page from '../../classes/Page'
import Hero from '../../modules/Hero'
import { app, breakpoints } from '../../utils/store'
import each from 'lodash/each'

import Navlist from '../../modules/Navlist'
import Slider from '../../modules/Slider'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)

export default class System extends Page {
    constructor() {
        super({
            id: 'single_system',
            element: '[data-app-page]',
            elements: {
                hero: '[data-carousel="hero"]',
                navlists: 'section.navlist',
                details: '#details',
                compositions: '[data-slider="compositions"]'
            },
            // scroller: app.device.mobile ? app.html : app.wrapper
        })

    }

    create() {
        super.create()

        // if(this.elements.details){ this.createPinSrolling() }

        if (app.statusbar) { this.createObserver() }
        if (this.elements.hero) { this.createHero() }
        if (this.elements.navlists) { this.createNavlist() }
        if (this.elements.compositions) { this.createCompositions() }
    }

    createHero() {
        this.hero = new Hero({ element: this.elements.hero })
    }

    createCompositions = () => {
        this.compositions = new Slider({ element: this.elements.compositions })
    }

    createNavlist = () => {
        if (this.elements.navlists instanceof window.NodeList || Array.isArray(this.elements.navlists)) {
            each(this.elements.navlists, (section) => {
                return new Navlist({ element: section })
            })
        } else {
            this.navlist = new Navlist({ element: this.elements.navlists })
        }
    }

    createObserver() {        
        this.anchors = {
            links: app.statusbar.querySelectorAll(`a[href^="#"]`),
            sections: new Array()
        }

        each(this.anchors.links, (link) => {
            this.anchors.sections.push(document.querySelector(`${link.hash}`))
        })

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                this.scroll.currentX = entry.boundingClientRect.x
                this.scroll.currentRatio = entry.intersectionRatio

                if (entry.isIntersecting) { // "Scrolling UP" this.scroll.currentY < this.scroll.previousY &&
                    // if (this.scroll.currentRatio > this.scroll.previousRatio) { // "Scrolling UP Enter"
                    each(this.anchors.links, (link) => link.classList.remove('active'))
                    app.statusbar.querySelector(`a[href="#${entry.target.id}"]`).classList.add('active')
                    // } else { // "Scrolling UP Leave"
                    // app.statusbar.querySelector(`a[href="#${entry.target.id}"]`).classList.remove('active')
                    // }
                    if (entry.target.id == 'details') {
                        app.statusbar.querySelector('ul.nav.actions').classList.add('active')
                    } 
                    // else {
                    //     app.statusbar.querySelector('ul.nav.actions').classList.remove('active')
                    // }
                } else {
                    if (entry.target.id == 'details') {
                        app.statusbar.querySelector('ul.nav.actions').classList.remove('active')
                    }
                }

                this.scroll.previousX = this.scroll.currentX
                this.scroll.previousRatio = this.scroll.currentRatio
            })
        }, {
            rootMargin: '0px',
            threshold: 0.2
        })

        each(this.anchors.sections, (section) => {
            // console.log(section)
            this.observer.observe(section)
        })
    }

    addEventListeners() {
        // app.preloader.once('completed', () => { app.scroll.style.setProperty('scroll-snap-type','y proximity') })
    }

    destroy() {
        super.destroy()
    }
}